export default __webpack_public_path__ + "static/media/Erlik's Ninth Seal of the Underworld.d4d56887.jpg";